import { createReducer } from 'redux-create-reducer'
export function getLoadingReducer<State>(
  initialState: State,
  updater: (
    state: State,
    props: any,
    loaderProps: Record<string, any>,
  ) => State,
  loadingFunctions: [string, string, string],
): (state: State, action: unknown) => State {
  const [loadAction, successAction, failAction] = loadingFunctions
  return createReducer<State, any>(initialState, {
    [loadAction](state, props) {
      return updater(state, props, {
        loading: true,
        loaded: false,
      })
    },

    [successAction](state, props) {
      return updater(state, props, {
        loading: false,
        loaded: true,
      })
    },

    [failAction](state, props) {
      return updater(state, props, {
        loading: false,
        loaded: false,
      })
    },
  })
}
